import { Formik } from "formik";
import { Grid, TextField, FormLabel, Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import { ModalFooter } from "../../../../components/common/Modal/ModalFooter";
import { useUnitMeasureStore } from "../../../../hooks/useUnitMeasureStore";
import { useBussinesAreaStore } from "../../../../hooks/useBussinesAreaStore";
import { useProductClassificationStore } from "../../../../hooks/useProductClassificationStore";

const dataunit = [
    { id: 1, name: 'Unidad', abbreviation: 'Ud.'},
    { id: 2, name: 'Kilogramo', abbreviation: 'Kg'},
]

const databussines = [
    { id: 1, name: 'area demo', idbranchoffice: '1'},
]

const dataclassification = [
    { id: 1, name: 'clasificacion demo', idbranchoffice: '1'},
]

export const SectionInventory: React.FC<any> = (props): JSX.Element | any => {

    const { dataInventory, setDataInventory, currentSection, handlePrevSection, handleNextSection, sections, clearState } = props;

    const { getUnitMeasure } = useUnitMeasureStore();
    const { getBussinesAreaByCompany, getBussinesArea } = useBussinesAreaStore();
    const { getProductClassification, getProductClassificationByCompany } = useProductClassificationStore();

    const [loadingdata, setLoadingdata] = useState<boolean>(false);

    const [unitMeasures, setUnitMeasures] = useState<any>([]);
    const [unitMeasureSelected, setUnitMeasureSelected] = useState<any>('');
    const [unitMeasuresOp, setUnitMeasuresOp] = useState<any>([]);
    const [unitMeasureOpSelected, setUnitMeasureOpSelected] = useState<any>('');
    const [bussinesArea, setBussinesArea] = useState<any>([]);
    const [businnesAreaSelected, setBusinnesAreaSelected] = useState<any>('');
    const [classifications, setClassifications] = useState<any>([]);
    const [classificationSelected, setClassificationSelected] = useState<any>('');

    useEffect(() => {
        getUnitMeasureApi();
        getBussinesAreaByCompanyApi();
        getProductClassificationByCompanyApi();
    },[]);

    useEffect(() => {
        if(dataInventory.idunitmeasure && unitMeasures){
            setCustomUnitMeasure(dataInventory.idunitmeasure, unitMeasures)
        }
    },[dataInventory.idunitmeasure, unitMeasures])

    const setCustomUnitMeasure = (idunitmeasure, unitMeasures) => {
        const data = unitMeasures.find(unit => unit.id == idunitmeasure);
        return setUnitMeasureSelected(data);
    }

    useEffect(() => {
        if(dataInventory.idunitmeasureoptional && unitMeasures){
            setCustomUnitMeasureOp(dataInventory.idunitmeasureoptional, unitMeasures)
        }
    },[dataInventory.idunitmeasureoptional, unitMeasures])

    const setCustomUnitMeasureOp = (idunitmeasureoptional, unitMeasures) => {
        const data = unitMeasures.find(unit => unit.id == idunitmeasureoptional);
        return setUnitMeasureOpSelected(data);
    }

    useEffect(() => {
        if(dataInventory.idbusinessarea && bussinesArea){
            setCustomBussinesArea(dataInventory.idbusinessarea, bussinesArea)
        }
    },[dataInventory.idbusinessarea, bussinesArea])

    const setCustomBussinesArea = (idbusinessarea, bussinesArea) => {
        const data = bussinesArea.find(area => area.id == idbusinessarea);
        return setBusinnesAreaSelected(data);
    }

    useEffect(() => {
        if(dataInventory.idclassification && classifications){
            setCustomClassification(dataInventory.idclassification, classifications)
        }
    },[dataInventory.idclassification, classifications])

    const setCustomClassification = (idclassification, classifications) => {
        const data = classifications.find(classification => classification.id == idclassification);
        return setClassificationSelected(data);
    }

    const getUnitMeasureApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = dataunit;
            // const response = await getUnitMeasure(search);
            if(!response){
                setUnitMeasures([]); setUnitMeasuresOp([]); setLoadingdata(false); return false;
            }else{
                setUnitMeasures(response || []); setUnitMeasuresOp(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getBussinesAreaByCompanyApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBussinesArea(search);
            if(!response){
                setBussinesArea([]); setLoadingdata(false); return false;
            }else{
                setBussinesArea(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getProductClassificationByCompanyApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getProductClassification(search);
            if(!response){
                setClassifications([]); setLoadingdata(false); return false;
            }else{
                setClassifications(response || []); setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.idunitmeasure) errors.idunitmeasure = "el campo es requerido";
        if(!values.idbusinessarea) errors.idbusinessarea = "el campo es requerido";
        // if(!values.idclassification) errors.idclassification = "el campo es requerido";
        // if(!values.minimumstock) errors.minimumstock = "el campo es requerido";
        // if(!values.maximumstock) errors.maximumstock = "el campo es requerido";
        return errors;
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
          event.preventDefault();
        }
    };

    const onCancel = () => {
        handlePrevSection && handlePrevSection();
    }

    const onSubmit = async(values)  => {
        setDataInventory(values)
        handleNextSection && handleNextSection();
    }

    return (
        <Grid sx={{height:'100%', position: 'relative'}}>
            <Formik initialValues={dataInventory} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Grid container sx={{maxHeight: '65vh', overflowY: 'scroll', paddingRight:'5px'}}>
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Unidad de medida:</FormLabel>
                                        <Autocomplete
                                            id="idunitmeasure"
                                            size="small"
                                            value={!!unitMeasureSelected ? unitMeasureSelected : null}
                                            options={unitMeasures || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idunitmeasure && touched.idunitmeasure ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setUnitMeasureSelected(newValue)
                                                setFieldValue('idunitmeasure', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} md={6}>
                                        <FormLabel>Unidad de medida opcional:</FormLabel>
                                        <Autocomplete
                                            id="idunitmeasureoptional"
                                            size="small"
                                            value={!!unitMeasureOpSelected ? unitMeasureOpSelected : null}
                                            options={unitMeasuresOp || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idunitmeasureoptional && touched.idunitmeasureoptional ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setUnitMeasureOpSelected(newValue)
                                                setFieldValue('idunitmeasureoptional', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid> */}
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Area de negocio:</FormLabel>
                                        <Autocomplete
                                            id="idbusinessarea"
                                            size="small"
                                            value={!!businnesAreaSelected ? businnesAreaSelected : null}
                                            options={bussinesArea || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idbusinessarea && touched.idbusinessarea ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setBusinnesAreaSelected(newValue)
                                                setFieldValue('idbusinessarea', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Clasificación:</FormLabel>
                                        <Autocomplete
                                            id="idclassification"
                                            size="small"
                                            value={!!classificationSelected ? classificationSelected : null}
                                            options={classifications || []}
                                            loading={loadingdata}
                                            getOptionLabel={(departament) => departament?.name || ''}
                                            isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                            renderInput={(params) => 
                                                <TextField {...params} label="" size="small"
                                                    error={errors.idclassification && touched.idclassification ? true : false}
                                                />
                                            }
                                            onChange={(e, newValue: any) => {
                                                setClassificationSelected(newValue)
                                                setFieldValue('idclassification', newValue ? newValue.id : "");
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Stock mínimo:</FormLabel>
                                        <TextField
                                            id="minimumstock"
                                            type="number" 
                                            name="minimumstock"
                                            fullWidth
                                            size="small"
                                            value={values.minimumstock}
                                            onChange={handleChange}
                                            error={errors.minimumstock && touched.minimumstock ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Stock máximo:</FormLabel>
                                        <TextField
                                            id="maximumstock"
                                            type="number" 
                                            name="maximumstock"
                                            fullWidth
                                            size="small"
                                            value={values.maximumstock}
                                            onChange={handleChange}
                                            error={errors.maximumstock && touched.maximumstock ? true : false}
                                            onKeyDown={handleKeyDown}
                                            InputProps={{
                                                inputProps: {
                                                    min: 1
                                                }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Siguiente'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Atrás"}
                                    onCancel={onCancel}
                                />
                            </div>
                        </form>
                    )
                }} 
            </Formik>
        </Grid>
    )
}